/**
 * Labstep
 *
 * @module components/OrderRequestTemplate/Action/Create
 * @desc Action to create a OrderRequestTemplate
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { Can } from 'labstep-web/components/Entity/Can';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { OrderRequest } from 'labstep-web/models/order-request.model';
import type React from 'react';
import type { OrderRequestTemplateActionCreateProps } from './types';

export const OrderRequestTemplateActionCreate: React.FC<
  OrderRequestTemplateActionCreateProps
> = ({ resource, activeGroup }) => (
  <Can
    entityName={resource.entityName}
    id={resource.id}
    action={Action.edit}
  >
    <EntityActionCreate
      entityName={OrderRequest.entityName}
      parentName={activeGroup?.entityName}
      parentId={activeGroup?.id}
      actionComponentProps={{
        type: 'button',
        text: 'Enable Template',
      }}
      body={{
        template_resource_id: resource.id,
        is_template: true,
        quantity: 1,
      }}
    />
  </Can>
);

export default withActiveGroup(OrderRequestTemplateActionCreate);
